import React, { useState, useEffect, useRef } from 'react';
import { ThemeProvider } from 'styled-components';

import Wysiwyg from '../Wysiwyg';

import Wrapper from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';
import { Container, Box, Panel } from './styles';
import Chevron from '-!svg-react-loader!../../ui/svgs/icon-chevron.svg';

interface IBox {
  title: string;
  text: string;
  key?: string;
}

interface IProps {
  theme?: string;
  heading: string;
  title: string;
  boxes: IBox[];
}

const Item: React.FC<{
  id: number;
  title: string;
  text: string;
  cleanedTheme: string;
  currentActive: number;
  setCurrentActive: (id?: number) => void;
}> = ({ id, title, text, cleanedTheme, currentActive, setCurrentActive }) => {

  const panelRef = useRef(null);

  const isActive = currentActive === id;
  const toggleActive = () => setCurrentActive( isActive ? undefined : id);
  const maxHeight = isActive ? `${panelRef.current.scrollHeight}px` : '0px';

  return (
    <>
      <Box onClick={toggleActive} className={`${isActive ? 'open' : ''}`}>
        {title}
        <Chevron className="chevron" />
      </Box>
      <Panel ref={panelRef} style={{ maxHeight: `${maxHeight}` }}>
        <Wysiwyg text={text} wrapper={false} theme={cleanedTheme} />
      </Panel>
    </>
  );
};

const Faqs = ({ theme, heading, title, boxes }: IProps) => {
  const [currentActive, setCurrentActive] = useState(undefined);
  const cleanedTheme = theme ? theme : 'white';

  const schemaObject = {
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    'mainEntity': []
  };

  const HeaderEl = title && heading === 'heading_2' ? 'h2' : 'h3';

  return (
    <ThemeProvider theme={themes.basic[cleanedTheme]}>
      <Wrapper size="reader" as={Container}>
        <HeaderEl className="title">{title}</HeaderEl>
        {boxes.map((box, index) => {
          schemaObject.mainEntity.push({
            '@type': 'Question',
            'position': index,
            'name': box.title,
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': box.text
            }
          });
          return (
            <Item
              key={'item_key_' + index}
              id={index}
              title={box.title}
              text={box.text}
              cleanedTheme={cleanedTheme}
              currentActive={currentActive}
              setCurrentActive={setCurrentActive}
            />
          );
        })}
      </Wrapper>
      {schemaObject && (
        <script
          key={`faqs-schema-${title}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaObject) }}
        />
      )}
    </ThemeProvider>
  );
};

export default Faqs;
